import { inject, Injectable } from "@angular/core";
import { BlacklistEntryDto, CreateBlacklistRequest } from "@dtos/blacklist.dto";
import { ApiService } from "@services/api.service";
import { EndPoints } from "@services/EndPoints";

@Injectable({ providedIn: 'root' })
export class BlacklistProvider {

  private readonly api = inject(ApiService);

  /**
   * OBTENER BLACKLIST DE UN CONDUCTOR
   * @param driverId - ID DEL CONDUCTOR
   * @returns ARRAY DE ENTRADAS DE BLACKLIST
   */
  async getDriverBlacklist(driverId: number): Promise<BlacklistEntryDto[] | null> {
    try {
      const response = await this.api.get<any[]>({
        url: EndPoints.driverBlackList.replace('{driver_id}', String(driverId))
      });

      if (!response) return null;

      return response.map(item => BlacklistEntryDto.fromJson(item));
    } catch (error) {
      console.error('Error al obtener blacklist del conductor:', error);
      return null;
    }
  }

  /**
   * ELIMINAR UNA ENTRADA DE BLACKLIST
   * @param blacklistId - ID DE LA ENTRADA DE BLACKLIST
   * @returns TRUE SI SE ELIMINO CORRECTAMENTE
   */
  async deleteBlacklistEntry(blacklistId: number): Promise<boolean> {
    try {
      await this.api.delete({
        url: EndPoints.deleteBlacklist.replace('{blacklistId}', String(blacklistId))
      });
      return true;
    } catch (error) {
      console.error('Error al eliminar entrada de blacklist:', error);
      return false;
    }
  }

  /**
   * ELIMINAR UN GRUPO DE BLACKLIST (CONDUCTOR + CLIENTE)
   * @param driverId - ID DEL CONDUCTOR
   * @param clientId - ID DEL CLIENTE
   * @returns TRUE SI SE ELIMINO CORRECTAMENTE
   */
  async deleteBlacklistGroup(driverId: number, clientId: number): Promise<boolean> {
    try {
      await this.api.post({
        url: EndPoints.deleteGroupBlacklist,
        body: {
          driver: driverId,
          client: clientId
        }
      });
      return true;
    } catch (error) {
      console.error('Error al eliminar grupo de blacklist:', error);
      return false;
    }
  }

  /**
   * CREAR UNA ENTRADA DE BLACKLIST
   * @param data - DATOS DE LA ENTRADA DE BLACKLIST
   * @returns TRUE SI SE CREO CORRECTAMENTE
   */
  async createBlacklist(data: CreateBlacklistRequest): Promise<boolean> {
    try {
      // ENVIAR DIRECTAMENTE COMO JSON BODY
      // La API espera: driver (singular), client (objeto con id y transport_types),
      // y subclients (array de objetos con id y transport_types)

      const requestBody = {
        driver: data.driver,
        client: {
          id: data.client.id,
          transport_types: data.client.transport_types
        },
        ...(data.subclients && data.subclients.length > 0 && {
          subclients: data.subclients.map(subclient => ({
            id: subclient.id,
            transport_types: subclient.transport_types
          }))
        })
      };

      await this.api.post({
        url: EndPoints.createBlacklist,
        body: requestBody
      });
      return true;
    } catch (error) {
      console.error('Error al crear entrada de blacklist:', error);
      return false;
    }
  }
}
